import React from "react";
import Aside from "./Aside";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

function AuthLayouts() {
  return (
    <>
    <Outlet />
  </>
  );
}

export default AuthLayouts;
